import { render, staticRenderFns } from "./DataEntryFields.vue?vue&type=template&id=243c0954&scoped=true&"
import script from "./DataEntryFields.vue?vue&type=script&lang=js&"
export * from "./DataEntryFields.vue?vue&type=script&lang=js&"
import style0 from "./DataEntryFields.vue?vue&type=style&index=0&id=243c0954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243c0954",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('243c0954')) {
      api.createRecord('243c0954', component.options)
    } else {
      api.reload('243c0954', component.options)
    }
    module.hot.accept("./DataEntryFields.vue?vue&type=template&id=243c0954&scoped=true&", function () {
      api.rerender('243c0954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/AdminPage/PageUsers/DataEntryFields.vue"
export default component.exports